import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=53d8b4e7&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=ts"
export * from "./MenuIcon.vue?vue&type=script&lang=ts"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=53d8b4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8b4e7",
  null
  
)

export default component.exports